import React, { useState, useCallback } from 'react';
import { useConnection, useWallet } from '@solana/wallet-adapter-react';
import { Keypair, PublicKey, Transaction } from '@solana/web3.js';
import { 
    TOKEN_2022_PROGRAM_ID, 
    TOKEN_PROGRAM_ID,
    createMintToInstruction, 
    getAssociatedTokenAddressSync, 
    createAssociatedTokenAccountIdempotentInstruction, 
    getAccount 
} from '@solana/spl-token';
import { Button } from './Button';
import { BN } from '@coral-xyz/anchor';
import { TOKENS } from '~/constants';
import authorityKeyJson from '~/programs/authority.json';

const TARGET_TOKEN = TOKENS.PLATFORM;
const MINT_ADDRESS = new PublicKey(TARGET_TOKEN.address);
const TOKEN_DECIMALS = TARGET_TOKEN.decimals; 
const MINT_AUTHORITY = Keypair.fromSecretKey(new Uint8Array(authorityKeyJson)); 
const MINT_AMOUNT_TOKENS = new BN(1000);
const IS_TOKEN_2022 = true

const mintAmountLamports = MINT_AMOUNT_TOKENS.mul(new BN(10 ** TOKEN_DECIMALS));
const tokenProgramId = IS_TOKEN_2022 ? TOKEN_2022_PROGRAM_ID : TOKEN_PROGRAM_ID;

export const FaucetButton = () => {
  const tokenSymbol = TARGET_TOKEN.symbol;

  const { connection } = useConnection();
  const { publicKey, sendTransaction, wallet } = useWallet();
  const [isLoading, setIsLoading] = useState(false);

  const handleFaucet = useCallback(async () => {
    if (!publicKey || !wallet || !sendTransaction) {
      alert('Wallet not connected!');
      return;
    }

    setIsLoading(true);

    try {
      const recipient = publicKey;

      const recipientAta = getAssociatedTokenAddressSync(
        MINT_ADDRESS,
        recipient,
        false,
        tokenProgramId
      );
      console.log(`Recipient ${tokenSymbol} ATA: ${recipientAta.toBase58()}`);

      let transaction = new Transaction();

      try {
        await getAccount(connection, recipientAta, 'confirmed', tokenProgramId);
        console.log(`Recipient ${tokenSymbol} ATA already exists.`);
      } catch (error: any) {
        console.log(`Recipient ${tokenSymbol} ATA not found, creating...`);
        transaction.add(
          createAssociatedTokenAccountIdempotentInstruction(
            publicKey,
            recipientAta,
            recipient,
            MINT_ADDRESS,
            tokenProgramId
          )
        );
      }

      transaction.add(
        createMintToInstruction(
          MINT_ADDRESS,
          recipientAta,
          MINT_AUTHORITY.publicKey,
          BigInt(mintAmountLamports.toString()),
          [],
          tokenProgramId
        )
      );

      const signature = await sendTransaction(transaction, connection, {
          signers: [MINT_AUTHORITY],
      });

      console.log(`Faucet transaction sent. Signature: ${signature}`);
      await connection.confirmTransaction(signature, 'confirmed');

      console.log(`Successfully minted ${MINT_AMOUNT_TOKENS.toString()} ${tokenSymbol}! Tx: ${signature}`);
      alert(`Successfully minted ${MINT_AMOUNT_TOKENS.toString()} ${tokenSymbol}!`);

    } catch (error: any) {
      console.error('Faucet error:', error);
      alert(`Faucet error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
    // useCallback 의존성 배열에서 Props 관련 제거, 내부 상수 사용
  }, [publicKey, connection, sendTransaction, wallet]); 

  if (!publicKey) {
    return null;
  }

  return (
    <div className="w-full">
      <Button
        onClick={handleFaucet}
        disabled={isLoading}
        loading={isLoading}
        type="primary"
        size="sm"
        className="w-full"
        aria-label={`Get ${tokenSymbol} Faucet Token`} // 내부 상수로 변경
      >
        {`💧 Get ${tokenSymbol}`} {/* 내부 상수로 변경 */}
      </Button>
    </div>
  );
}; 